import {
  Box,
  Flex,
  Text,
  Divider,
  Checkbox,
  CheckboxGroup,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
  Skeleton,
} from '@chakra-ui/react'

import { useGetUserDevicesQuery } from '../../locations/api/locationsApi'
import { useGetDeviceGroupListQuery } from '../../settings/api/api'
import { useGetAllLocationsQuery } from '../api/reportsApi'
import { TreeDevice } from '../pages/TreeDevice'

export const EnergyConsumptionReportFilters = ({
  selectedLocations,
  selectedGroups,
  selectedDevices,
  setSelectedLocations,
  setSelectedGroups,
  setSelectedDevices,
}) => {
  const { data: locations, isLoading } = useGetAllLocationsQuery({})
  const { data: devicesGroups, isLoading: isUserGroupsLoading } =
    useGetDeviceGroupListQuery({})
  const { data: userDevices, isLoading: isUserDevicesLoading } = useGetUserDevicesQuery(
    {
      locationIds: selectedLocations,
    },
    {
      skip: !selectedLocations?.length,
    },
  )
  const locationIds = locations?.results?.map((location) => location.id)
  const groupIds = devicesGroups?.map((group) => group.id)

  return (
    <>
      {/* Location */}
      <Flex direction="column" gap={3} w="full">
        <Flex justify="space-between" align="center">
          <Text color="#484848" fontWeight={700} fontSize="14px" fontFamily="Inter">
            Select Location/s
          </Text>
          <Checkbox
            isChecked={selectedLocations?.length === locationIds?.length}
            onChange={(e) => {
              setSelectedLocations(e.target.checked ? locationIds : [])
              setSelectedDevices([])
              setSelectedGroups([])
            }}
          >
            Select all
          </Checkbox>
        </Flex>
        {isLoading ? (
          <Flex gap={3}>
            {[...Array(2)].map((_, i) => (
              <Skeleton key={i} height="40px" width="120px" borderRadius="md" />
            ))}
          </Flex>
        ) : (
          <CheckboxGroup
            value={selectedLocations?.map(String)}
            onChange={(value) => {
              setSelectedLocations(value.map(Number))
              setSelectedDevices([])
              setSelectedGroups([])
            }}
          >
            <Flex gap={3} wrap="wrap">
              {locations?.results?.map((location) => (
                <Checkbox
                  key={location.id}
                  value={location.id.toString()}
                  borderRadius="md"
                  px={3}
                  py={2}
                  bg="#F5F6F7"
                >
                  {location.title}
                </Checkbox>
              ))}
            </Flex>
          </CheckboxGroup>
        )}
      </Flex>
      <Divider />
      {selectedLocations?.length > 0 && (
        <Flex w="full">
          <Box w="100%">
            <Tabs
              isFitted
              variant="unstyled"
              colorScheme="gray"
              onChange={(index) => {
                if (index === 0) setSelectedGroups([])
                if (index === 1) setSelectedDevices([])
              }}
            >
              <TabList bg="gray.100" p="1" borderRadius="full">
                <Tab
                  _selected={{ bg: 'white', color: 'black', fontWeight: 'bold' }}
                  _hover={{ bg: 'gray.200' }}
                  borderRadius="full"
                >
                  Devices
                </Tab>
                <Tab
                  _selected={{ bg: 'white', color: 'black', fontWeight: 'bold' }}
                  _hover={{ bg: 'gray.200' }}
                  borderRadius="full"
                >
                  Groups
                </Tab>
              </TabList>
              <TabPanels mt={4}>
                <TabPanel padding="0px">
                  <VStack align="start" spacing={2}>
                    <Text
                      color="#484848"
                      fontWeight={700}
                      fontSize="14px"
                      fontFamily="Inter"
                    >
                      Select Device/s
                    </Text>
                    {isUserDevicesLoading
                      ? [...Array(4)].map((_, i) => (
                          <Skeleton
                            key={i}
                            height="32px"
                            width="100%"
                            borderRadius="md"
                          />
                        ))
                      : userDevices?.map((device) => (
                          <TreeDevice
                            key={device.id}
                            device={device}
                            selected={selectedDevices}
                            setSelected={setSelectedDevices}
                          />
                        ))}
                  </VStack>
                  <Divider mt={4} />
                </TabPanel>
                <TabPanel padding="0px">
                  <VStack align="start" spacing={2}>
                    <Flex justify="space-between" align="center" width="full">
                      <Text
                        color="#484848"
                        fontWeight={700}
                        fontSize="14px"
                        fontFamily="Inter"
                      >
                        Select Group/s
                      </Text>
                      <Checkbox
                        isChecked={selectedGroups?.length === groupIds?.length}
                        onChange={(e) =>
                          setSelectedGroups(e.target.checked ? groupIds : [])
                        }
                      >
                        Select all
                      </Checkbox>
                    </Flex>
                    {isUserGroupsLoading ? (
                      [...Array(4)].map((_, i) => (
                        <Skeleton key={i} height="32px" width="100%" borderRadius="md" />
                      ))
                    ) : (
                      <CheckboxGroup
                        value={selectedGroups?.map(String)}
                        onChange={(value) => setSelectedGroups(value.map(Number))}
                      >
                        <Flex gap={3} wrap="wrap">
                          {devicesGroups?.map((group) => (
                            <Checkbox
                              key={group.id}
                              value={group.id.toString()}
                              borderRadius="md"
                              px={3}
                              py={2}
                              bg="#F5F6F7"
                            >
                              {group.name}
                            </Checkbox>
                          ))}
                        </Flex>
                      </CheckboxGroup>
                    )}
                  </VStack>
                  <Divider mt={4} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Flex>
      )}
    </>
  )
}
